<template>
    <img class="logo w-[195px] h-auto" src="/images/logo.png" alt="Logo" />
</template>
